import React, { useEffect, useState } from "react";
import {
  formatABN,
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatMobile,
  formatNumber,
  formatPhone,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import {
  API,
  cddOptions,
  get,
  riskProfile,
  verificationMethods,
} from "../../config";
import { useOrganization } from "../../lib/context/OrganisationContext";

const BeneficiaryDetailsPopup = ({
  beneficiaryId,
  // toggleShowModal,
  showView,
  setShowView,
}) => {
  const { organizationData } = useOrganization();
  const [beneficiaryDetail, setBeneficiaryDetail] = useState(null);
  const [beneficiaryLoading, setBeneficiaryLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(
          `${API.BENEFICARY_DETAILS}/` + beneficiaryId
        );
        setBeneficiaryDetail(data.data);
        setBeneficiaryLoading(false);
      } catch (e) {
        return null;
      }
    }
    fetchData();
  }, [beneficiaryId, setBeneficiaryDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={"Beneficiary Details"}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      {beneficiaryLoading ? (
        <Spin full expand={true} />
      ) : (
        <div className="md:p-0 p-4">
          <div className="modal-content">
            <CardTitle className="text-md mb-2">Personal Details</CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>
                  {getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "vendors",
                    "Vendor"
                  )}
                  :
                </strong>{" "}
                {beneficiaryDetail?.vendor
                  ? formatSubcontractorName(beneficiaryDetail?.vendor)
                  : "-"}
              </p>
              <p>
                <strong>First Name:</strong>{" "}
                {beneficiaryDetail?.first_name
                  ? beneficiaryDetail?.first_name
                  : "-"}
              </p>
              <p>
                <strong>Last Name:</strong> {beneficiaryDetail?.last_name}
              </p>
              <p>
                <strong>Email Address:</strong> {beneficiaryDetail?.email}
              </p>
              <p>
                <strong>Phone Number:</strong>{" "}
                {beneficiaryDetail?.phone
                  ? formatPhone(beneficiaryDetail?.phone)
                  : ""}
              </p>
              <p>
                <strong>Mobile Number:</strong>{" "}
                {beneficiaryDetail?.mobile
                  ? formatMobile(beneficiaryDetail?.mobile)
                  : "-"}
              </p>
              <p>
                <strong>Business Name:</strong>{" "}
                {beneficiaryDetail?.business_name
                  ? beneficiaryDetail?.business_name
                  : "-"}
              </p>

              <p>
                <strong>ABN:</strong>{" "}
                {beneficiaryDetail?.abn
                  ? formatABN(beneficiaryDetail?.abn)
                  : "-"}
              </p>
              <p>
                <strong>Licence Number:</strong>{" "}
                {beneficiaryDetail?.license_number
                  ? beneficiaryDetail?.license_number
                  : "-"}
              </p>
              <p>
                <strong>Code:</strong>{" "}
                {beneficiaryDetail?.code ? beneficiaryDetail?.code : "-"}
              </p>

              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Address:</strong>{" "}
                {formatedAddress(
                  beneficiaryDetail?.street,
                  beneficiaryDetail?.suburb?.name,
                  beneficiaryDetail?.state?.name,
                  beneficiaryDetail?.postal_code
                )}
              </p>
              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Street Address:</strong>{" "}
                {formatedAddress(
                  beneficiaryDetail?.shipping_street,
                  beneficiaryDetail?.shipping_suburb?.name,
                  beneficiaryDetail?.shipping_state?.name,
                  beneficiaryDetail?.shipping_postal_code
                )}
              </p>
            </div>
          </div>
          {beneficiaryDetail?.account_name && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Bank Account Details
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>Bank Name:</strong>{" "}
                  {beneficiaryDetail?.bank
                    ? beneficiaryDetail?.bank?.abbreviation +
                      "-" +
                      beneficiaryDetail?.bank?.name
                    : "-"}
                </p>
                <p>
                  <strong>Bank Account Name:</strong>{" "}
                  {beneficiaryDetail?.account_name
                    ? beneficiaryDetail?.account_name
                    : "-"}
                </p>
                <p>
                  <strong>BSB:</strong>{" "}
                  {beneficiaryDetail?.bsb
                    ? formatBSBNumber(beneficiaryDetail?.bsb)
                    : "-"}
                </p>
                <p>
                  <strong>Account Number:</strong>{" "}
                  {beneficiaryDetail?.account_number
                    ? formatAccountNumber(beneficiaryDetail?.account_number)
                    : "-"}
                </p>
                <p>
                  <strong>Opening Balance:</strong>{" "}
                  {beneficiaryDetail?.opening_balance
                    ? "$" +
                      formatNumber(Number(beneficiaryDetail?.opening_balance))
                    : "$0.00"}
                </p>
              </div>
            </div>
          )}

          {beneficiaryDetail?.kyc && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Proof of ID for Customer Due Diligence (CDD)
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                {beneficiaryDetail?.kyc?.photo_id && (
                  <p>
                    <strong>Photo ID:</strong>{" "}
                    <a
                      href={beneficiaryDetail.kyc.photo_id}
                      download
                      target="_blank"
                      className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </p>
                )}
                {beneficiaryDetail?.kyc?.primary_id && (
                  <p>
                    <strong>Primary ID:</strong>{" "}
                    <a
                      href={beneficiaryDetail.kyc.primary_id}
                      download
                      target="_blank"
                      className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </p>
                )}
                {beneficiaryDetail?.kyc?.secondary_id && (
                  <p>
                    <strong>Secondary ID:</strong>{" "}
                    <a
                      href={beneficiaryDetail.kyc.secondary_id}
                      download
                      target="_blank"
                      className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </p>
                )}
                <p>
                  <strong>Verification Date:</strong>{" "}
                  {beneficiaryDetail?.kyc?.verification_date
                    ? beneficiaryDetail?.kyc?.verification_date
                    : "-"}
                </p>
                <p>
                  <strong>Verified By:</strong>{" "}
                  {beneficiaryDetail?.kyc?.verified_by_user
                    ? formatSubcontractorName(
                        beneficiaryDetail?.kyc?.verified_by_user
                      )
                    : "-"}
                </p>
                <p>
                  <strong>Method:</strong>{" "}
                  {beneficiaryDetail?.kyc?.method
                    ? verificationMethods?.find(
                        (item) => item.value === beneficiaryDetail?.kyc?.method
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>Risk Profile:</strong>{" "}
                  {beneficiaryDetail?.kyc?.risk
                    ? riskProfile?.find(
                        (item) => item.value === beneficiaryDetail?.kyc?.risk
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>CDD:</strong>{" "}
                  {beneficiaryDetail?.kyc?.cdd
                    ? cddOptions?.find(
                        (item) => item.value === beneficiaryDetail?.kyc?.cdd
                      )?.label
                    : "-"}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </ResponsiveDrawerForm>
  );
};

export default BeneficiaryDetailsPopup;
